<div class="container-fluid">
  <div class="row pl--1rem8  d-flex align-items-center">
    <div class="col-md-10 step-title">
      <h5>Build New Visa</h5>

    </div>
  </div>
  <div class="vd-container">
    <div class="task-header">
      <div class="d-flex">
        <div class="flex-grow-1 px-3 pb-3">
          <div class="row">
            <span class="stand-out"> {{visaInfo?.visaName}}</span>
            <!-- <span class="one-liner">{{notification}} </span> -->
          </div>
          <div class="task-header-summary">
            <div class="border-right pr-3 border-dark float-left">
              <label class="float-left mb-0">Country : {{visaInfo?.country?.countryCode}}</label>
            </div>
            <div class="border-right px-3 border-dark float-left">
              <label class="float-left mb-0">Language : {{visaInfo?.language?.name}}</label>
            </div>
            <div class="border-right px-3 border-dark float-left">
              <label class="float-left mb-0">Form Type : {{visaInfo?.formType?.name}}</label>
            </div>
            <div class="border-right px-3 border-dark float-left"
              *ngIf="!(immigrantForms.includes(visaInfo?.formType?.code))">
              <label class="float-left mb-0">Visa Type : {{visaInfo?.visaType?.name}}</label>
            </div>
            <div class="border-right px-3 border-dark float-left"
              *ngIf="!(immigrantForms.includes(visaInfo?.formType?.code))">
              <label class="float-left mb-0">Petition Type : {{visaInfo?.petitionType?.name}}</label>
            </div>
            <div class="border-right px-3 border-dark float-left"
              *ngIf="(immigrantForms.includes(visaInfo?.formType?.code))">
              <label class="float-left mb-0">Catagory : {{visaInfo?.immCategory?.name}}</label>
            </div>
            <div class="border-right px-3 border-dark float-left"
              *ngIf="(immigrantForms.includes(visaInfo?.formType?.code))">
              <label class="float-left mb-0">Classification : {{visaInfo?.immClassification?.name}}</label>
            </div>
            <div class="px-3 border-dark float-left">
              <label class="float-left mb-0">Sub-Task Type : {{visaInfo?.subTaskType?.name}}</label>
            </div>
            <!-- <div class="border-right px-3 border-dark float-left">
            <label class="float-left mb-0">Users : Petiitoner + 3</label>
          </div> -->
          </div>
        </div>
      </div>
    </div>
    <p-divider type="dashed"></p-divider>
    <p-tabView [activeIndex]="index" class="vd-summaryTask-tab py-3 my-2" (onChange)="handleChange($event)">
      <p-tabPanel *ngFor="let item of stepsList; let i = index;">
        <ng-template pTemplate="header">
          <div class="icon-holder">
            <hr *ngIf="i === 0" class="zero-index-line" />
            <hr *ngIf="i > 0 && i < (stepsList.length - 1)" class="non-zero-index-line" />
            <hr *ngIf="i === (stepsList.length - 1)" class="final-index-line" />
            <span class="header-icon border rounded-circle p-3" [ngClass]="{
          'inprogress': i===index,
          'new':i !== index}">
              <img alt="" src='{{"assets/images/RFE_icon.png"}}'>
            </span>
          </div>
          <label>
            <span *ngIf="item">{{i+1}}. {{ item}}</span>
          </label>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
    <div class="p-3">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
